import { FiltersType, ListingRequest } from '@/api/types';
import { client } from '@/client';
import { JobTitle } from '@/client/accounts';
import { PartialRequestMultiselect } from '@/components/form/generic/PartialRequestMultiselect';
import { useAppSelector } from '@/hooks/store';
import { selectCurrentAccount } from '@/store/features/account';
import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

type JobTitlesMultiselectInputProps = {
  onChange: (value: JobTitle[]) => void;
  onBlur?: () => void;
  additionalFilters?: FiltersType;
  selectedOptions?: JobTitle[];
  isDisabled?: boolean;
  accountId?: string;
} & Omit<HTMLAttributes<HTMLSelectElement>, 'onChange' | 'defaultChecked'>;

export const JobTitlesMultiselectInput: React.FC<
  JobTitlesMultiselectInputProps
> = ({
  onChange,
  onBlur,
  className,
  additionalFilters,
  selectedOptions,
  isDisabled,
  accountId,
}) => {
  const { t } = useTranslation();
  const currentAccount = useAppSelector(selectCurrentAccount);
  const fetchJobTitles = isDisabled
    ? undefined
    : async (params: ListingRequest) =>
        await client.accountEntities.getJobTitles(
          params,
          accountId || currentAccount?.id || '',
        );

  return (
    <PartialRequestMultiselect
      dataKey="name"
      fetchService={fetchJobTitles}
      filter
      display="chip"
      optionLabel="name"
      optionValue="value"
      placeholder={t('generic.select')}
      maxSelectedLabels={10}
      additionalFilters={additionalFilters}
      selectedOptions={selectedOptions}
      className={className}
      handleOnChange={onChange}
      onBlur={onBlur}
      disabled={isDisabled}
      isNotListingResponse
    />
  );
};
